<template>
  <div
    class="fixed bottom-0 inset-x-0 px-4 pb-4 pt-12 md:p-0 md:inset-0 md:flex md:items-center md:justify-center z-50"
    :class="current.type"
    v-if="visible"
  >
    <div class="fixed inset-0 transition-opacity" @click.prevent="dismiss">
      <div class="absolute inset-0 bg-gray-900 opacity-75"></div>
    </div>
    <div class="block absolute top-0 right-0 pt-4 pr-4">
      <button
        type="button"
        class="text-gray-400 hover:text-gray-500 focus:outline-none focus:text-gray-500 transition ease-in-out duration-150"
        aria-label="Close"
        @click.prevent="dismiss"
      >
        <svg
          class="h-6 w-6"
          stroke="currentColor"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
    </div>
    <div
      class="bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all md:max-w-xl lg:max-w-3xl md:w-full md:p-6"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-headline"
    >
      <div class="w-full" v-html="current.body"></div>
    </div>
  </div>
</template>
<script>
import { AjaxCaller } from '@ssdcode/cms-partials';
export default {
  name: 'ModalWrapper',
  mixins: [AjaxCaller],
  props: {
    id: {
      required: false,
    },
    preventBackgroundScrolling: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      route: '/modal',
      visible: false,
      current: {},
      collection: {},
    };
  },
  created() {
    window.EventBus.listen('toggle-modal', this.fetch);

    const escapeHandler = event => {
      if (event.key === 'Escape' && this.visible) {
        this.dismiss();
      }
    };

    document.addEventListener('keydown', escapeHandler);

    this.$once('hook:destroyed', () => {
      document.removeEventListener('keydown', escapeHandler);
    });
  },
  mounted() {
    this.initialize();

    let modals = document.getElementsByClassName('reveal-modal');

    if (modals.length === 0) {
      return;
    }

    [...modals].forEach(modal => {
      modal.onclick = event => {
        this.fetch(event.currentTarget.getAttribute('data-modal-id'));
        this.dispatchEvent(true);
      };
    });
  },
  watch: {
    current: {
      immediate: true,
      handler(newValue) {
        this.visible = Object.keys(newValue).length > 0;
        this.toggleBackgroundScrolling();
      },
    },
  },
  methods: {
    initialize() {
      if (this.id && parseInt(this.id) !== 0) {
        this.fetch(this.id);
      }
    },
    toggleBackgroundScrolling() {
      if (!this.preventBackgroundScrolling) {
        return;
      }
      if (this.visible) {
        document.body.style.setProperty('overflow', 'hidden');
      } else {
        document.body.style.removeProperty('overflow');
      }
    },
    fetch(id) {
      this.dismiss();
      if (this.collection.hasOwnProperty(id)) {
        this.current = this.collection[id];
        return;
      }
      this.makeAjaxRequest(
        response => {
          this.requestSuccess(response, id);
        },
        this.requestFailure,
        { id },
        this.route
      );
    },
    requestSuccess(response, id) {
      this.stopProcessing();
      if (!response.data.body) {
        return;
      }
      this.collection[id] = this.current = {
        type: response.data.type,
        body: response.data.body,
      };
    },
    requestFailure(error) {
      this.stopProcessing();
      throw new Error(error);
    },
    dismiss() {
      this.current = {};
      this.dispatchEvent(false);
    },
    dispatchEvent(visible) {
      window.EventBus.fire('modal-toggled', { visible });
    },
  },
};
</script>
